// src/data/translations.js

const translations = {
  English: {
    // ── Home ──
    heroTitle1: "We're here to",
    heroHighlight1: "help",
    heroTitle2: "resolve &",
    heroHighlight2: "protect",
    heroTitle3: "you!",
    heroSub: "Start your positive journey towards financial inclusion and real protection for you and your loved ones.",
    dontWorry: "Don't worry, we've got you!",
    aiDesc: "Our AI ZARA is here to understand and resolve your issue — now.",
    letsStart: "Let's get started",
    formSub: "Enter your details so we can find your active services and help you better.",
    phonePlaceholder: "03XX-XXXXXXX",
    phoneLabel: "Enter your mobile number",
    networkLabel: "Please select your service provider",
    networkPlaceholder: "Please select your service provider",
    nextBtn: "Next →",
    aiChatBtn: "Start Conversation",
    aiSupportBadge: "AI Support",
    aiHeroTitle: "Need help? Chat with ZARA",
    aiHeroText: "Get quick help with refunds, complaints, claims, and service requests.",
    aiChatTitle: "Live chat with ZARA",
    aiChatIntro: "Ask me anything about your service, complaint , refund and / or Un-subscription.",
    aiChatPlaceholder: "Type your question...",
    aiSendBtn: "Send",
    quickTopicRefund: "Refund",
    quickTopicComplaint: "Complaint",
    quickTopicClaim: "Claim",
    quickTopicFeedback: "Feedback",
    quickPromptRefund: "I need help with a refund",
    quickPromptComplaint: "I want to register a complaint",
    quickPromptClaim: "I need help with a claim",
    quickPromptFeedback: "I want to share feedback",
    aiReplyRefund: "I can help you with cancellation and refund requests. Please provide your Phone Number",
    aiReplyClaim: "I can help you submit or review a claim. Share the issue and I’ll guide you.",
    aiReplyComplaint: "I can help you register a complaint, Please write details.",
    aiReplyFeedback: "Thanks for sharing your feedback. I can help you submit it quickly.",
    aiReplyGeneral: "I’m here to help with your account, services, complaints, refund requests, and claims.",
    safeText: "Your information is safe and secure with us.",
    otpVerifyTitle: "Verify your phone number",
    otpVerifySub: "Enter the OTP sent to your mobile number.",
    otpSentTo: "Sent to",
    otpPlaceholder: "Enter OTP",
    otpTimerLabel: "Expires in",
    otpResendButton: "Resend OTP",
    otpVerifyButton: "Verify OTP",
    otpClose: "Close",
    sendingOtp: "Sending OTP...",
    verifyingOtp: "Verifying...",
    otpSentMessage: "OTP sent successfully. It expires in 5 minutes.",
    otpExpired: "OTP expired. Please resend.",
    otpInvalid: "Please enter the OTP.",
    otpSendFailed: "Failed to send OTP. Please try again.",
    otpVerifyFailed: "OTP verification failed. Please try again.",
    phoneInvalid: "Please enter a valid mobile number",
    networkInvalid: "Please select your service provider",

    // ── Services ──
    activeServices: "Your Active Services",
    serviceFound: "We found services linked to {phone}.",
    whatToDo: "What would you like to do?",
    selectServiceHint: "Please select a service above, then choose an action.",
    serviceSelected: '"{name}" selected — now choose an action.',
    loadingServices: "Looking for your services...",
    noServicesTitle: "No Policy Found",
    noServicesSub: "No active subscription found on {network} for this number.",
    retryBtn: "Try Again 🔄",
    serviceType: "Service Type",
    subscribedOn: "Subscribed on",
    benefitsBtn: "View Benefits",
    maxCoverage: "Max Coverage",
    monthly: "Monthly",
    month: "month",
    mo: "mo",
    lastCharged: "Last Charged",
    claimSupport: "Claim Support",
    pricePlan: "Price Plan",
    youCanGet: "You Can Get",

    // ── Action buttons ──
    cancelLabel: "Cancel & Refund",
    cancelSub: "Cancel service and get refund",
    claimLabel: "Make a Claim",
    claimSub: "File a claim",
    complaintLabel: "Register Complaint",
    complaintSub: "Lodge a complaint",
    feedbackLabel: "Give Feedback",
    feedbackSub: "Share your experience",
    feedbackSubmitFailed: "Unable to submit feedback. Please try again.",
    feedbackSubmitting: "Submitting...",
    feedbackSuccessMessage: "Thank you for your feedback.",
    complaintSubmitFailed: "Unable to submit complaint. Please try again.",
    complaintSubmitting: "Submitting...",
    cancelSubmitFailed: "Unable to submit cancellation. Please try again.",
    cancelReasonRequired: "Please choose a reason for cancellation.",
    cancelSubmitting: "Submitting...",
    serviceLabel: "Service",

    // ── Cancel & Refund ──
    cancelPageTitle: "Cancel & Refund",
    cancelPageSub: "The service you want to cancel",
    cancelReasonLabel: "Please tell us why you want to cancel:",
    cancelInfoText: "If you request the cancellation of this service, it will be deactivated immediately. In cases where the service was activated without your authorization, the deducted amount may be refunded, subject to verification and eligibility requirements. Any approved refund will be processed within 5 working days from the date of confirmation of eligibility.",
    cancelConfirmBtn: "Yes, Cancel & Get Refund",
    cancelBackBtn: "Go Back",

    // ── Processing ──
    processingConfirmTitle: "Confirm Cancellation",
    processingConfirmSub: "Are you sure you want to cancel this service?",
    processingConfirmBtn: "Confirm Cancel",
    processingBackBtn: "Go Back",
    processingTitle: "Your Request is Being Processed",
    processingSub: "We are processing your cancellation request. Please wait...",
    cancelDoneTitle: "Cancellation Complete",
    cancelDoneSub: "Your service has been successfully cancelled.",
    cancelDoneSub2: "You will not be charged for this service anymore.",
    cancelDoneNext: "Next →",
    refundTitle: "We're Sad, you are Leaving! 😢",
    refundDesc: "We well happy to serve you again , soon.",
    refundSummaryTitle: "Refund Summary",
    refundDeducted: "Your Deducted Amount",
    refundComplimentary: "Complimentary from Us",
    refundTotal: "Total Refund Amount",
    refundNote: "If you are eligible, refund will be credited to your account within 3–5 working days.",
    refundNextBtn: "Next →",
    thankYouTitle: "Thank You!",
    thankYouSub: "Thank you for trusting us!",
    thankYouSub2: "We are always here to help you.",
    goHomeBtn: "Go to Home",

    // ── Complaint ──
    complaintPageTitle: "Register Complaint",
    complaintPageSub: "Register your complaint — we will resolve it",
    step1Title: "Identify the Issue",
    step1Sub: "What is your problem? Choose from below.",
    step2Title: "Describe the Issue",
    step2Sub: "The more detail you provide, the faster it will be resolved.",
    step3Title: "Complaint Registered!",
    complaintRegistered: "Your complaint has been successfully registered.",
    complaintIdLabel: "Complaint ID",
    complaintFollowUp: "We will contact you within 2–3 days. Please note this ID.",
    complaintNextBtn: "Next →",
    complaintSubmitBtn: "Submit Complaint ✓",
    complaintBackBtn: "Go Back",
    complaintDescLabel: "Describe your issue in detail",
    complaintDescPlaceholder: "E.g. 'Rs. 99 was deducted from my account without my consent...'",
    complaintInfoText: "Your complaint will be reviewed within 2–3 working days. We will notify you via SMS/notification.",
    goHomeBtn2: "Go to Home",

    // Complaint types
    cType1: "Wrong Deduction",
    cType2: "Subscribed Without Consent",
    cType3: "Claim Rejected",
    cType4: "Slow Support",
    cType5: "Service Issue",
    cType6: "Other Issue",

    // ── Feedback ──
    feedbackPageTitle: "Give Feedback",
    feedbackPageSub: "Help us improve with your feedback",
    feedbackStep1Title: "Share Your Opinion",
    feedbackStep1Sub: "Your experience helps us serve you better.",
    feedbackRatingLabel: "How was your experience?",
    feedbackCategoryLabel: "What would you like to give feedback about?",
    feedbackStep2Title: "Tell Us More",
    feedbackStep2Sub: "Your feedback will help us serve you better.",
    feedbackCommentLabel: "Write your experience in your own words (optional)",
    feedbackCommentPlaceholder: "Write your feedback here...",
    feedbackSubmitBtn: "Submit Feedback ✓",
    feedbackBackBtn: "Go Back",
    feedbackDoneTitle: "Thank You!",
    feedbackDoneSub: "Your feedback will help us improve our service.",
    feedbackDoneSub2: "We are always here for you. 😊",
    feedbackNextBtn: "Next →",

    // Feedback categories
    fCat1: "Service Quality",
    fCat2: "Support Team",
    fCat3: "App Experience",
    fCat4: "Pricing & Plans",
    fCat5: "Claims Process",
    fCat6: "Other",

    // ── Shared ──
    backBtn: "← Back",
    ratingLabel: ["Very Bad", "Not Good", "Okay", "Good", "Excellent!"],
    ZARAMessage: "I am ZARA,here to help.",
    ZARAFeatures: ["Quick & Easy", "Safe & Secure", "24/7 Support", "Trusted by Millions"],
  },

  "Roman Urdu": {
    // ── Home ──
    heroTitle1: "Hum",
    heroHighlight1: "madad",
    heroTitle2: "ke liye hazir hain, aap ke masail hal karein aur aap ka",
    heroHighlight2: "tahaffuz",
    heroTitle3: "karein.",
    heroSub: "Apna behtar mustaqbil, financial inclusion aur asli hifazat ki taraf aaj se safar shuru karein.",
    dontWorry: "Fikr mat karein, hum hain!",
    aiDesc: "Hamari AI ZARA aap ka masla samajh kar hal karegi — abhi.",
    letsStart: "Chaliye shuru karte hain",
    formSub: "Apni details enter karein taa ke hum aap ki active services dhoondh kar behtar madad kar sakein.",
    phonePlaceholder: "03XX-XXXXXXX",
    phoneLabel: "Apna mobile number enter karein",
    networkLabel: "Barah-e-karam service provider select karein",
    networkPlaceholder: "Service provider select karein",
    nextBtn: "Aagay Barein →",
    aiChatBtn: "Baath shuru karein",
    aiSupportBadge: "AI Support",
    aiHeroTitle: "Madad chahiye? ZARA se baat karein",
    aiHeroText: "Refunds, complaints, claims aur service requests mein jaldi madad hasil karein.",
    aiChatTitle: "ZARA ke saath live chat",
    aiChatIntro: "Apni service, complaint, refund ya unsubscribe karne se mutaliq kisi bhi maloomat ya madad ke liye hum se rabta karein.",
    aiChatPlaceholder: "Apna sawal likhein...",
    aiSendBtn: "Bhejein",
    quickTopicRefund: "Refund",
    quickTopicComplaint: "Shikayat",
    quickTopicClaim: "Claim",
    quickTopicFeedback: "Feedback",
    quickPromptRefund: "Mujhe refund mein madad chahiye",
    quickPromptComplaint: "Main shikayat register karwana chahta hoon",
    quickPromptClaim: "Mujhe claim mein madad chahiye",
    quickPromptFeedback: "Main feedback share karna chahta hoon",
    aiReplyRefund: "Main cancellation aur refund requests mein madad kar sakta hoon. Bataein kaunsa service manage karna hai.",
    aiReplyClaim: "Main claim submit ya review karne mein madad kar sakta hoon. Masla bataein, main guide karunga.",
    aiReplyComplaint: "Main aap ki complaint register karne mein madad kar sakti hoon. Barah-e-karam apni complaint ki tafseelaat darj karein.",
    aiReplyFeedback: "Shukriya, aap ki feedback share karne ke liye. Main isay jaldi submit karne mein madad kar sakta hoon.",
    aiReplyGeneral: "Main aap ki account, services, complaints, refund requests aur claims mein madad karne ke liye hun.",
    safeText: "Aap ki maloomat mehfooz aur secure hai.",
    otpVerifyTitle: "Apna phone number verify karein",
    otpVerifySub: "Aap ke mobile number par bheja gaya OTP yahan enter karein.",
    otpSentTo: "Bheja gaya",
    otpPlaceholder: "OTP yahan likhein",
    otpTimerLabel: "Yeh expire hoga",
    otpResendButton: "OTP dobara bhejein",
    otpVerifyButton: "OTP verify karein",
    otpClose: "Band karein",
    sendingOtp: "OTP bheja ja raha hai...",
    verifyingOtp: "Verify kiya ja raha hai...",
    otpSentMessage: "OTP kamyabi se bhej diya gaya. Yeh 5 minutes mein expire ho jayega.",
    otpExpired: "OTP expire ho gaya. Barah-e-karam dobara bhejein.",
    otpInvalid: "Barah-e-karam OTP enter karein.",
    otpSendFailed: "OTP bhejne mein masla aya. Dobara koshish karein.",
    otpVerifyFailed: "OTP verify karne mein masla aya. Dobara koshish karein.",
    phoneInvalid: "Barah-e-karam valid mobile number enter karein",
    networkInvalid: "Barah-e-karam service provider select karein",

    // ── Services ──
    activeServices: "Aap ki Active Services",
    serviceFound: "Humne {phone} se juri services dhoondh li hain.",
    whatToDo: "Aap kya karna chahte hain?",
    selectServiceHint: "Pehle upar se koi service select karein, phir action choose karein.",
    serviceSelected: '"{name}" select ho gayi — ab koi action choose karein.',
    loadingServices: "Services dhoondh rahe hain...",
    noServicesTitle: "No Policy Found",
    noServicesSub: "{network} par is number ki koi active subscription nahi hai.",
    retryBtn: "Dobara Koshish Karein 🔄",
    serviceType: "Service Ki Qisam",
    subscribedOn: "Subscribe ki tareeq",
    benefitsBtn: "Fayde (Benefits) Dekhein",
    maxCoverage: "Zyada se Zyada Coverage",
    monthly: "Maheena",
    month: "maah",
    mo: "maah",
    lastCharged: "Aakhri Deduction",
    claimSupport: "Claim Support",
    pricePlan: "Qeemat Ka Plan",
    youCanGet: "Aapko Mil Sakta Hai",

    // ── Action buttons ──
    cancelLabel: "Cancel & Refund",
    cancelSub: "Service band karein refund paayein",
    claimLabel: "Claim Karein",
    claimSub: "Claim file karein",
    complaintLabel: "Shikayat Darj Karein",
    complaintSub: "Apna masla bataein",
    feedbackLabel: "Rai Dein",
    feedbackSub: "Apna tajurba share karein",
    feedbackSubmitFailed: "Feedback bhejne mein masla aya. Dobara koshish karein.",
    feedbackSubmitting: "Feedback bheja ja raha hai...",
    feedbackSuccessMessage: "Aap ka feedback shukriya. Hum ise dekh rahe hain.",
    complaintSubmitFailed: "Shikayat darj karne mein masla aya. Dobara koshish karein.",
    complaintSubmitting: "Darj kiya ja raha hai...",
    cancelSubmitFailed: "Cancellation bhejne mein masla aya. Dobara koshish karein.",
    cancelReasonRequired: "Barah-e-karam cancellation ki wajah choose karein.",
    cancelSubmitting: "Bhej rahe hain...",
    serviceLabel: "Service",

    // ── Cancel & Refund ──
    cancelPageTitle: "Cancel & Refund",
    cancelPageSub: "Aap jis service ko band karna chahte hain",
    cancelReasonLabel: "Band karne ki wajah bata dein:",
    cancelInfoText: "Agar aap is service ko band karte hain, to yeh foran deactivate kar di jayegi. Agar yeh service aap ki raza mandi (consent) ke baghair activate ki gayi thi, to tasdeeq aur eligibility check ke baad aap ki deducted amount refund kar di jayegi. Is ke ilawa, hamari janib se deducted amount ke barabar complimentary amount bhi provide ki jayegi. Kisi bhi approved refund ko tasdeeq ke din se 5 kaam ke dinon mein process kiya jayega.",
    cancelConfirmBtn: "Haan, Band Karein aur Refund Lein",
    cancelBackBtn: "Peechay Jayein",

    // ── Processing ──
    processingConfirmTitle: "Cancel Ki Tasdeeq",
    processingConfirmSub: "Kya aap is service ko band karna chahte hain?",
    processingConfirmBtn: "Confirm Cancel",
    processingBackBtn: "Peechay Jayein",
    processingTitle: "Aap ki Request Process Ho Rahi Hai",
    processingSub: "Hum aap ki cancellation request process kar rahe hain. Thoda intezar karein...",
    cancelDoneTitle: "Cancel Mukammal",
    cancelDoneSub: "Aap ki service kamyabi se band kar di gayi hai.",
    cancelDoneSub2: "Ab aap se is service ke liye koi charges nahi liye jayenge.",
    cancelDoneNext: "Agay →",
    refundTitle: "Khushkhabri! 🎉",
    refundDesc: "Kyunke is service ke liye aap se baghair valid consent ke amount liya gaya tha, is liye aap ka deducted amount aur hamari taraf se complimentary amount (same as deducted amount) aap ke account mein refund kiya jayega.",
    refundSummaryTitle: "Refund Summary",
    refundDeducted: "Aap ka Deducted Amount",
    refundComplimentary: "Hamari Taraf se Complimentary",
    refundTotal: "Total Refund Amount",
    refundNote: "Agar aap eligible hain, to refund 3–5 working days ke andar aap ke account mein credit kar diya jayega.",
    refundNextBtn: "Agay →",
    thankYouTitle: "Shukriya!",
    thankYouSub: "Hum par bharosa karne ka shukriya!",
    thankYouSub2: "Hum hamesha aap ki madad ke liye maujood hain.",
    goHomeBtn: "Home Par Jayein",

    // ── Complaint ──
    complaintPageTitle: "Shikayat Darj Karein",
    complaintPageSub: "Shikayat darj karein — hum hal karenge",
    step1Title: "Masle Ki Nishaan Dehi",
    step1Sub: "Aap ka kya masla hai? Neeche se choose karein.",
    step2Title: "Masla Bayan Karein",
    step2Sub: "Jitna detail dein utna jaldi hal hoga.",
    step3Title: "Shikayat Darj Ho Gayi!",
    complaintRegistered: "Aap ki shikayat kamyabi se register ho gayi hai.",
    complaintIdLabel: "Complaint ID",
    complaintFollowUp: "Hum 2–3 din mein aap se rabta karenge. Yeh ID note kar lein.",
    complaintNextBtn: "Agay Barein →",
    complaintSubmitBtn: "Shikayat Darj Karein ✓",
    complaintBackBtn: "Peechay Jayein",
    complaintDescLabel: "Apna masla tafseel se bataein",
    complaintDescPlaceholder: "Maslan: 'Mere account se bina izazat Rs. 99 kat gaye...'",
    complaintInfoText: "Aap ki shikayat 2–3 kaamiabi din mein review ki jayegi. Hum aap ko SMS/notification ke zariye update karenge.",
    goHomeBtn2: "Home Par Jayein",

    // Complaint types
    cType1: "Galat Deduction",
    cType2: "Bina Izazat Subscribe",
    cType3: "Claim Reject Hua",
    cType4: "Support Dheema Tha",
    cType5: "Service Mein Masla",
    cType6: "Koi Aur Masla",

    // ── Feedback ──
    feedbackPageTitle: "Rai Dein",
    feedbackPageSub: "Apni rai se hum behtar banein",
    feedbackStep1Title: "Apni Rai Dein",
    feedbackStep1Sub: "Aap ka tajurba humein behtar banane mein madad karta hai.",
    feedbackRatingLabel: "Aap ka tajurba kaisa raha?",
    feedbackCategoryLabel: "Kis cheez ke baare mein feedback dena chahte hain?",
    feedbackStep2Title: "Kuch Aur Bataein?",
    feedbackStep2Sub: "Aap ki baat sun ke hum apni service behtar karenge.",
    feedbackCommentLabel: "Apna tajurba apne alfaaz mein likhein (ikhtiyari)",
    feedbackCommentPlaceholder: "Aap ka feedback yahan likhein...",
    feedbackSubmitBtn: "Feedback Submit Karein ✓",
    feedbackBackBtn: "Peechay Jayein",
    feedbackDoneTitle: "Shukriya Aap Ka!",
    feedbackDoneSub: "Aap ki rai humein aur behtar banne mein madad karegi.",
    feedbackDoneSub2: "Hum hamesha aap ki madad ke liye yahan hain. 😊",
    feedbackNextBtn: "Agay Barein →",

    // Feedback categories
    fCat1: "Service Ki Quality",
    fCat2: "Support Team",
    fCat3: "App Ka Tajurba",
    fCat4: "Qeemat Aur Plans",
    fCat5: "Claim Ka Process",
    fCat6: "Koi Aur Baat",

    // ── Shared ──
    backBtn: "← Peechay",
    ratingLabel: ["Bahut Bura", "Theek Nahi", "Theek Hai", "Acha Laga", "Zabardast!"],
    ZARAMessage: "Main ZARA hoon. main aap ki rahnumai karungi.",
    ZARAFeatures: ["Tez aur Asaan", "Safe & Secure", "24/7 Support", "Lakhon Ka Bharosa"],
  },
};

export default translations;